import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  HoverCard,
  imageZoom,
  Reveal,
  Stagger,
} from "../../../../components/motion";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";

const CMS_IMAGE_BASE =
  "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-services";

const REASON_CARDS = [
  { id: "Card1", image: `${CMS_IMAGE_BASE}/airport-transfer-tailored-to-you.png` },
  { id: "Card2", image: `${CMS_IMAGE_BASE}/airport-transfer-time-well-spent.png` },
  { id: "Card3", image: `${CMS_IMAGE_BASE}/airport-transfer-travel-with-confidence.png` },
  { id: "Card4", image: `${CMS_IMAGE_BASE}/airport-transfer-privacy-you-can-trust.png` },
  {
    id: "Card5",
    image: `${CMS_IMAGE_BASE}/airport-transfer-fluent-respectful-culturally-aware.png`,
  },
  {
    id: "Card6",
    image: `${CMS_IMAGE_BASE}/airport-transfer-professionalism-at-every-turn.png`,
  },
];

export const WhyChooseTaxiSection = () => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);

  return (
    <div className="tw:bg-[#F9F9F9] tw:border-t tw:border-t-[#F1F1F1] tw:py-12 tw:lg:py-[70px]">
      <div className="tw:px-5 tw:lg:px-[82px]">
        <Reveal className="tw:text-center tw:space-y-[10px]">
          <div className="tw:font-hanken-grotesk tw:font-semibold tw:uppercase tw:tracking-[3px] tw:text-[8px] tw:text-[#D4B055]">
            {t("servicesPage.WhyChooseUs.Kicker")}
          </div>
          <div className="tw:font-libre-caslon-display tw:text-[#282828] tw:text-[22px] tw:lg:text-[38px] tw:leading-[26px] tw:lg:leading-[46px]">
            {t("servicesPage.WhyChooseUs.Title")}
          </div>
        </Reveal>

        {/* The cards arrive one after another, and hovering one lifts it
            while its photo zooms in slightly. Both come from the shared
            motion primitives, so the timing matches the rest of the site. */}
        <Stagger className="tw:mt-[30px] tw:lg:mt-[44px] tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:lg:grid-cols-3 tw:gap-4 tw:lg:gap-5">
          {REASON_CARDS.map((card) => (
            <HoverCard
              key={card.id}
              className="tw:relative tw:h-[280px] tw:rounded-[5px] tw:overflow-hidden tw:flex tw:items-end"
            >
              <motion.img
                variants={imageZoom()}
                src={card.image}
                alt={t(`servicesPage.WhyChooseUs.${card.id}.Title`)}
                className="tw:absolute tw:inset-0 tw:w-full tw:h-full tw:object-cover"
              />
              <div className="tw:absolute tw:inset-0 tw:bg-[linear-gradient(180deg,rgba(0,0,0,0.05)_0%,rgba(0,0,0,0.78)_100%)]"></div>
              <div className="tw:relative tw:z-10 tw:p-[22px] tw:font-hanken-grotesk">
                <div className="tw:font-libre-caslon-display tw:text-white tw:text-[21px] tw:leading-[28px] tw:mb-[6px]">
                  {t(`servicesPage.WhyChooseUs.${card.id}.Title`)}
                </div>
                <div
                  className={cn(
                    "tw:text-[#E2E2E2]",
                    getTypographyClass(12)
                  )}
                >
                  {t(`servicesPage.WhyChooseUs.${card.id}.Description`)}
                </div>
              </div>
            </HoverCard>
          ))}
        </Stagger>
      </div>
    </div>
  );
};
